import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../CustomControls/Breadcrumb';
import features from '../../assets/images/dashboard.png';
import { get as getCookie } from 'js-cookie';

const Dashboard = props => {
  const name = getCookie('name');
  const breadCrumbPaths = [{ id: 1, title: 'Home', path: '/' }];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <div>
                  <Row>
                    <Col lg="9" sm="8">
                      <div className="p-4">
                        <h5 className="text-primary">Welcome back {name}! </h5>
                        <br />
                        <h6>Naztec - Release Information</h6>
                        <div className="text-muted">
                          <p>Your latest update as at 10-Jul-26</p>
                          <ul>
                            <li>Added Fuel Levy (%) field to Client Profile, configurable per client with up to 2 decimal places</li>
                            <li>Department Summary report now includes Fuel Levy, calculated on the subtotal before GST</li>
                            <li>GST on the Department Summary report is now calculated on subtotal + fuel levy</li>
                            <li>Department Summary report now displays the GST rate (%) alongside the GST amount</li>
                            <li>Fixed the Department Summary report picking up credit notes from the wrong month</li>
                          </ul>
                        </div>
                        <div className="text-muted">
                          <p>Update as at 21-May-26</p>
                          <ul>
                            <li>
                              Fixed requisition listing customer search not matching partial names (e.g. "Reserve H" now correctly finds
                              "Reserve Hotel")
                            </li>
                            <li>Fixed requisition listing search filters not applying correctly when changed after an initial search</li>
                            <li>Fixed pressing the back button on a requisition form requiring the user to start from scratch</li>
                            <li>Fixed Operations &gt; Pick List showing "No data available"</li>
                            <li>Date filter fields now always default to the current month across all screens</li>
                            <li>Search by Customer and Department added across all operation listing screens</li>
                          </ul>
                        </div>
                        <div className="text-muted">
                          <p>Update as at 12-Oct-22</p>
                          <ul>
                            <li>Big fixes on bulk dispatch date not picking up the default requisition delivery date</li>
                          </ul>
                        </div>
                        <div className="text-muted">
                          <p>Update as at 07-Oct-22</p>
                          <ul>
                            <li>Big fixes on bulk dispatch</li>
                            <li>Big fixes on dipatch auto numbering</li>
                          </ul>
                        </div>
                        <div className="text-muted">
                          <p>Update as at 05-Sep-22</p>
                          <ul>
                            <li>Fixed the GMT date filter bug on the department summary</li>
                          </ul>
                        </div>
                        <div className="text-muted">
                          <p>Update as at 27-Aug-22</p>
                          <ul>
                            <li>Reset Password functionality</li>
                            <li>Department summary report space decreased in the header</li>
                            <li>Bug fix on the sorting order of the requisition and dispatch listing</li>
                          </ul>
                        </div>
                        <div className="text-muted">
                          <p>Update as at 19-Aug-22</p>
                          <ul>
                            <li>New bulk dispatches feature</li>
                            <li>Requisition and dispatch listing sort order by date and client</li>
                            <li>Dispatch by default will have the delivery date set from the requisition </li>
                            <li>Department summary report's date will be set to the previous month's start and end date </li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg="3" sm="4" className="align-self-center">
                      <div>
                        <img src={features} alt="" className="img-fluid d-block" />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.defaultProps = {
  devices: {}
};

export default Dashboard;
